module.exports = __webpack_public_path__ + "static/mouth-mask-standards-from-china-according-to-spain-33ecdea210883045f58afbfe821e556a.png";